export type SuperContaContext = {
  workflow?: Record<string, unknown>;
  empresa?: Record<string, unknown>;
  kanban?: Record<string, number>;
  accion?: Record<string, unknown>;
};

let current: SuperContaContext | null = null;

export function setSuperContaContext(ctx: SuperContaContext | null): void {
  current = ctx;
}

export function getSuperContaContext(): SuperContaContext | null {
  return current;
}

export function clearSuperContaContext(): void {
  current = null;
}
